import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/grammar.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark MS 4, 470 Bl. 72<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: unknown<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (167k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Bertonio's 'Art and Very Copious Grammar of the Aymara Language'</title>
            <meta name="description" content="An English translation of ON BERTONIO'S 'ART AND VERY COPIOUS GRAMMAR OF THE AYMARA LANGUAGE' by Gottfried Wilhelm Leibniz, date unknown" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON BERTONIO'S <var>ART AND VERY COPIOUS GRAMMAR OF THE AYMARA LANGUAGE</var></h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>MS 4, 470 Bl. 72r</b>]<br /><br />
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;It is commonly said that the languages in America are so numerous that almost every valley seems to have its own distinct language. However, Father Ludovico Bertonio, a Roman of the Society of Jesus in the Peruvian province of the West Indies who published a book in Spanish titled Arte della lengua Aymara—printed in octavo in Rome, 1603—writes as follows in the prefatory letter addressed to Father Claudio Acquaviva, the Superior General of the Society: 'Although in this little book' (the author states that he has already spent ten years in the Indies devoted to the study of this language) [<b>MS 4, 470 Bl. 72v</b>] 'only the principles of the Aymara language are set forth, yet since most of the peoples of the Indies have languages that are not very different and use nearly the same phrases and expressions, I trust that this work will be useful for learning not only the language of the Aymara province but also that of many other diverse peoples'.<a name="1" href="#note1"><sup>1</sup></a> This is what he said. From this, I judge it probable that those languages of neighbouring peoples are also similar to one another and originate from the same source, though they are more corrupted and varied there than in our regions, due to the barbarity of the people, who act with hostility toward one another and consequently communicate less with each other. Thus, since languages are in constant change, each one's own peculiar change has produced a difference only in appearance. But our scholars, having been misled, have imagined as many different languages as there are dialects.<br />
                 <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> Ludovico Bertonio, <var>Arte y grammatica muy copiosa de la lengua Aymara</var> (Rome: Zannetti, 1603), 8.<br />
                <br /><br />
                &#169; Lloyd Strickland 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
